import { render, staticRenderFns } from "./SlideDeckSectionSelect.vue?vue&type=template&id=b320aeb0&scoped=true"
import script from "./SlideDeckSectionSelect.vue?vue&type=script&lang=ts"
export * from "./SlideDeckSectionSelect.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckSectionSelect.vue?vue&type=style&index=0&id=b320aeb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b320aeb0",
  null
  
)

export default component.exports